<template>
    <v-row class="mb-3 ">
        <v-col class="my-0 py-0 d-flex flex-column justify-space-between" cols="12" lg="12">
            <h3 class="d-flex flex-row align-center justify-space-between my-orange mt-3 mb-10">
                <div>
                    <v-img v-if="grupo.imagem_grupo" width="100px" contain height="auto" class="rounded-sm mr-5"
                        :src="`https://api.mylegis.com.br/assets/${grupo.imagem_grupo}`" />
                    {{ grupo.nome_grupo }}
                    <v-btn outlined x-small class="ml-5" v-if="isOwner" @click="
                        edit.nome_grupo = grupo.nome_grupo;
                    showEditGroup = true;
                    ">
                        <v-icon small>mdi-pencil</v-icon>Editar
                    </v-btn>
                </div>
                <v-btn text @click="reloadGrupo"><v-icon color="black">mdi-refresh</v-icon> Atualizar</v-btn>
            </h3>
        </v-col>
        <v-col cols=12 >
            <v-tabs fixed-tabs color="#F15A24" v-model="active">
                <v-tab  :to="`/painel/grupo/${grupo.id}`" value="feed">
                    <v-icon class="mr-2">mdi-rss</v-icon>Feed do Grupo
                </v-tab>
                <v-tab value="files">
                    <v-icon class="mr-2">mdi-folder</v-icon>Arquivos do Grupo
                </v-tab>
            </v-tabs>
        </v-col>
    </v-row>
</template>
<style scoped>
a {
    text-decoration: none;
    color: black !important;
}

a:hover {
    text-decoration: none;
}

</style>
<script>

export default {
    data: () => ({
        active: 1,
        grupo: { administradores: [] },

    }),
    mounted() {
        this.reloadGrupo();
    },
    computed: {
        groups() {
            return this.$store.state.filteredGroups;
        },
        isAdmin() {
            // return false
            return this.grupo.administradores.find(
                (e) => e.directus_users_id.id === this.$store.state.user.id
            );
        },
        isOwner() {
            return this.grupo.user_created === this.$store.state.user.id;
        },
        user() {
            return this.$store.state.user;
        },
    },
    methods: {

        reloadGrupo() {
            this.$http
                .get(
                    'items/grupos/' +
                    this.$route.params.id_grupo +
                    '?fields=integrantes.*,administradores.*,administradores.directus_users_id.*,integrantes.directus_users_id.*,*'
                )
                .then((res) => {
                    this.grupo = res.data.data;
                 
                });
        }
    }
}
</script>